import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { ModelService } from '../model/service/model.service';
import { MspTableComponent, mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { OperationalSystemInterface } from 'src/app/util/interfaces/operationalSystem';
import { OperationalSystemService } from './service/operational-system.service';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';

@Component({
	selector: 'register-form-operational-system',
	standalone: true,
	imports: [CommonModule, FormsModule, MspTableComponent, DotBounceLoadingEffectModule],
	templateUrl: './operational-system.component.html',
	styleUrl: './operational-system.component.scss',
})
export class OperationalSystemComponent implements OnInit {
	labels: any = {
		lbl_geral_selecione: 'Select',
		lbl_geral_novo: 'New',
		lbl_geral_salvar: 'Save',
		lbl_geral_voltar: 'Back',
		lbl_geral_excluir: 'Delete',
		lbl_geral_confirmar: 'Confirm',
		lbl_successful_updated: 'Successful updated',
		lbl_salvo_com_sucesso: 'Successful created',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
	};

	operationalSystemInterface: OperationalSystemInterface = {
		id: undefined,
		operational_system: '',
		type: '',
		ms_string: '',
	};

	isLoadingLabels = true;
	isLoadingOperationalSystems = true;

	operationalSystemsList: OperationalSystemInterface[] = [];
	ciTypeList: ciTypesInterface[] = [];

	searchHeader: mspTableHeaderI[] = [
		{ name: 'operational_system', value: 'lbl_asset_sistema_operacional', colType: 'text' },
		{ name: 'type_label', value: 'lbl_asset_tipo_ci', colType: 'text' },
		{ name: 'ms_string', value: 'MS String', colType: 'text' },
	];

	constructor(
		private notification: NotificationService,
		private labelsService: LabelsService,
		private modelService: ModelService,
		private operationalSystemService: OperationalSystemService
	) {}

	ngOnInit(): void {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getAllOperationalSystems();
		this.getAllCiType();
	}

	getAllOperationalSystems(): void {
		this.operationalSystemService.getOperationalSystems().subscribe((data) => {
			this.operationalSystemsList = data;
			this.isLoadingOperationalSystems = false;
		});
	}

	getAllCiType(): void {
		this.modelService.getAllCiType().subscribe((ciTypes) => {
			this.ciTypeList = ciTypes.filter((ciType) => {
				return ciType['table'] === 'workstations' || ciType['table'] === 'servers';
			});
		});
	}

	clearInputs(isNew: boolean): void {
		this.operationalSystemInterface = {
			id: isNew ? '' : undefined,
			operational_system: '',
			type: '',
			ms_string: '',
		};

		if (isNew === false) {
			this.isLoadingOperationalSystems = true;
			this.getAllOperationalSystems();
		}
	}

	cleanValues(): void {
		this.operationalSystemInterface = {
			id: '',
			operational_system: '',
			type: '',
			ms_string: '',
		};

		this.operationalSystemsList = [];
		this.isLoadingOperationalSystems = true;
		this.getAllOperationalSystems();
	}

	validateForm(): void {
		if (this.operationalSystemInterface.operational_system === '' || this.operationalSystemInterface.type === '') {
			this.notification.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.save();
	}

	save(): void {
		if (this.operationalSystemInterface.id) {
			this.operationalSystemService.putOperationalSystem(this.operationalSystemInterface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.notification.setNotificationMessage(this.labels.lbl_erro_nome_ja_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
					this.cleanValues();
					this.clearInputs(false);
				}
			});
		} else {
			this.operationalSystemService.postOperationalSystem(this.operationalSystemInterface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.notification.setNotificationMessage(this.labels.lbl_erro_nome_ja_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.cleanValues();
					this.clearInputs(false);
				}
			});
		}
	}

	deleteOperationalSystem(event: Event): void {
		if (!this.operationalSystemInterface.id) return;

		if ((event.target as HTMLElement).classList.contains('double-click')) {
			this.operationalSystemService.deleteOperationalSystems([this.operationalSystemInterface.id]).subscribe((data) => {
				this.notification.setNotificationMessage(this.labels.lbl_edocs_status_excluido || this.labels.lbl_geral_excluir);
				this.cleanValues();
				this.clearInputs(false);
			});
		} else {
			(event.target as HTMLElement).classList.add('double-click');

			setTimeout(() => {
				(event.target as HTMLElement).classList.remove('double-click');
			}, 2000);
		}
	}

	openForm(item: OperationalSystemInterface): void {
		this.operationalSystemInterface = {
			id: item.id,
			operational_system: item.operational_system,
			type: item.type,
			type_label: item.type_label,
			ms_string: item.ms_string,
		};
	}
}
